// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import PaymentSummary from "../PaymentDetails/PaymentSummary";
// import AttachedPrescription from "../presecription/AttachedPrescription";
// import { apiPOST } from "../../utilities/apiHelpers";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import scrollToTop from "../../utilities/scrollToTop";
// import ButtonWithLoader from "../Button/ButtonWithLoader";

// const PaymentStep = ({ stepperProgressCartData, setStepperProgressCartData, globalConfig }) => {
//     const userId = useSelector((state) => state.user?.userData?.id);
//     const [selectedOption, setSelectedOption] = useState('online');
//     const [loading, setLoading] = useState(false);
//     const navigate = useNavigate()
//     const handleOptionChange = (event) => {
//         setSelectedOption(event.target.value);
//     };
//     const addOrderAndItems = async () => {
//         setLoading(true);
//         if (selectedOption === 'cod') {
//             const addCodOrderPayload = {
//                 userId,
//                 addressId: stepperProgressCartData?.selectedAddress?._id,
//                 prescriptionId: stepperProgressCartData?.selectedPrescription[0]?._id,
//                 orderType: selectedOption,
//                 mode: 'order',
//                 totalPayment: stepperProgressCartData?.totalCartAmount
//             }
//             try {
//                 const addCodOrderResponse = await apiPOST(`/v1/order/add`, addCodOrderPayload);
//                 if (addCodOrderResponse) {
//                     if (addCodOrderResponse?.data?.data && stepperProgressCartData?.cartData?.length) {
//                         toast.success('Order Placed successfully')
//                         stepperProgressCartData?.cartData && stepperProgressCartData?.cartData?.length !== 0 && stepperProgressCartData?.cartData?.map(async (item) => {
//                             console.log(addCodOrderResponse?.data);
//                             const addOrderItemPayload = {
//                                 orderId: addCodOrderResponse?.data?.data?.id,
//                                 productId: item?.productId,
//                                 quantity: item?.quantity,
//                             }
//                             try {
//                                 const orderItemResponse = await apiPOST(`/v1/order-item/add`, addOrderItemPayload);
//                                 if (orderItemResponse) {
//                                     setLoading(false);
//                                     navigate(`/cod-success-page/${addCodOrderResponse?.data?.data?.id}`)
//                                 }
//                             } catch (error) {
//                                 console.log("Error Order Adding Item::", error);
//                             }
//                         })
//                     }
//                 }
//             } catch (error) {
//                 console.log('Error adding COD order::', error)
//                 setLoading(false);
//             }
//         } else {
//             try {
//                 const addOrderPayload = {
//                     userId,
//                     addressId: stepperProgressCartData?.selectedAddress?._id,
//                     prescriptionId: stepperProgressCartData?.selectedPrescription[0]?._id,
//                     orderType: selectedOption,
//                     mode: 'order',
//                     totalPayment: stepperProgressCartData?.totalCartAmount
//                 }
//                 let addOrderResponse;
//                 try {
//                     addOrderResponse = await apiPOST(`/v1/order/add`, addOrderPayload);

//                 } catch (error) {
//                     console.log("Error Placing order::", addOrderResponse);
//                 }
//                 if (addOrderResponse && addOrderResponse.status) {
//                     toast.success('Order added successfully')
//                     setLoading(false);
//                     if (addOrderResponse?.data?.data && stepperProgressCartData?.cartData?.length) {
//                         const addOrderItemsPromises = stepperProgressCartData?.cartData.map(async (item) => {
//                             const addOrderItemPayload = {
//                                 orderId: addOrderResponse?.data?.data?.id,
//                                 productId: item?.productId,
//                                 quantity: item?.quantity,
//                             };
//                             try {
//                                 return await apiPOST(`/v1/order-item/add`, addOrderItemPayload);
//                             } catch (error) {
//                                 console.log("Error Adding Order Item::", error);
//                                 return null;
//                             }
//                         });
//                         const orderItemsResponses = await Promise.all(addOrderItemsPromises);
//                         const allOrderItemsAdded = orderItemsResponses.every(response => response && response.status);
//                         console.log("addOrderResponse::", addOrderResponse?.data?.data);
//                         if (allOrderItemsAdded && addOrderResponse?.data?.data?.id) {
//                             setLoading(true);
//                             const payload = {
//                                 mode: 'order',
//                                 orderType: selectedOption,
//                             };
//                             const checkoutResponse = await apiPOST(`/v1/payment/create-checkout/${addOrderResponse?.data?.data?.id}`, payload);
//                             console.log('checkoutResponse', checkoutResponse);
//                             if (checkoutResponse.status) {
//                                 setLoading(false);
//                                 const checkoutUrl = checkoutResponse?.data?.data?.url;
//                                 console.log(checkoutUrl);
//                                 window.location.replace(checkoutUrl);
//                             } else {
//                                 console.error("Failed to create checkout session:", checkoutResponse.data);
//                                 toast.error('Failed to create checkout session');
//                                 setLoading(false);
//                             }
//                         } else {
//                             console.log("Error adding order items");
//                             setLoading(false);
//                             toast.error('Error adding order items');
//                         }
//                     }
//                 } else {
//                     console.log("Error adding order")
//                     setLoading(false)
//                 }
//             } catch (error) {
//                 toast.error('Error', error)
//                 setLoading(false)
//             }
//         }
//     };

//     useEffect(() => {
//         scrollToTop()
//     }, [])
//     return <div>
//         <div className="lg:flex gap-5 my-4">
//             <div className="lg:w-1/2 flex flex-col">
//                 <h2 className="text-2xl font-bold text-[18px]">Select Your Payment Method</h2>
//                 <div className="space-y-4 p-4">
//                     <div className={`flex items-center p-4 border rounded-lg bg-[#FFFFFF] ${selectedOption === 'online' ? 'border-green-500' : 'border-gray-300'}`}>
//                         <input
//                             type="radio"
//                             id="payOnline"
//                             name="paymentOption"
//                             value="online"
//                             checked={selectedOption === 'online'}
//                             onChange={handleOptionChange}
//                             className="form-radio h-5 w-5 text-green-500 cursor-pointer"
//                         />
//                         <label htmlFor="payOnline" className="ml-3 text-lg cursor-pointer font-medium">
//                             Pay Online
//                         </label>
//                     </div>
//                     <div className={`flex items-center p-4 border rounded-lg bg-[#FFFFFF] ${selectedOption === 'cod' ? 'border-green-500' : 'border-gray-300'}`}>
//                         <input
//                             type="radio"
//                             id="cashOnDelivery"
//                             name="paymentOption"
//                             value="cod"
//                             checked={selectedOption === 'cod'}
//                             onChange={handleOptionChange}
//                             className="form-radio h-5 w-5 text-green-500 cursor-pointer"
//                         />
//                         <label htmlFor="cashOnDelivery" className="ml-3 text-lg cursor-pointer font-medium">
//                             Cash on Delivery
//                         </label>
//                     </div>
//                 </div>
//                 <div className={`${stepperProgressCartData?.cartData?.length === 0 ? 'hidden' : 'lg:ml-auto'}`}>
//                     <ButtonWithLoader loading={loading} buttonText={`${selectedOption === 'cod' ? "Place order" : "Proceed to payment"}`} onClick={addOrderAndItems} width={"w-[200px]"} />
//                 </div>
//                 {/* <button className="bg-[#14967F] font-[600] text-[#FFFFFF] w-[200px] rounded-[30px] p-2 self-end" onClick={addOrderAndItems}>Proceed to Payment</button> */}
//             </div>
//             <div className="flex flex-col lg:w-1/2">
//                 <PaymentSummary type="summary" item={stepperProgressCartData ? stepperProgressCartData : []} globalConfig={globalConfig} />
//                 <AttachedPrescription type="cart" stepperProgressCartData={stepperProgressCartData} />
//             </div>
//         </div>
//     </div>
// }

// export default PaymentStep; 

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PaymentSummary from "../PaymentDetails/PaymentSummary";
import AttachedPrescription from "../presecription/AttachedPrescription";
import { apiPOST } from "../../utilities/apiHelpers";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import scrollToTop from "../../utilities/scrollToTop";
import ButtonWithLoader from "../Button/ButtonWithLoader";

const PaymentStep = ({ stepperProgressCartData, setStepperProgressCartData, globalConfig }) => {
    const userId = useSelector((state) => state.user?.userData?.id);
    const [selectedOption, setSelectedOption] = useState('online');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [isServiceable, setIsServiceable] = useState(false); // Controls the button lock

    // ─────────────────────────────────────────────
    // Load Razorpay script dynamically
    // ─────────────────────────────────────────────
    const loadRazorpayScript = () => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = process.env.REACT_APP_RAZORPAY_URL || "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });
    };

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };

    // ─────────────────────────────────────────────
    // Open Razorpay Modal (replaces window.location.replace(checkoutUrl))
    // ─────────────────────────────────────────────
    //     const openRazorpayModal = (checkoutData, orderId) => {
    //         const options = {
    //             key: checkoutData.key_id,
    //             amount: checkoutData.amount,
    //             currency: checkoutData.currency,
    //             order_id: checkoutData.razorpayOrderId,
    //             name: "Your Store Name",
    //             description: "Order Payment",
    //             prefill: {
    //                 name: checkoutData.customer_name,
    //                 email: checkoutData.customer_email,
    //             },
    //             theme: {
    //                 color: "#14967F", // your brand color
    //             },
    //             // ─────────────────────────────────────────────
    //             // Called when payment is successful
    //             // ─────────────────────────────────────────────
    //             handler: async function (response) {
    //                 try {
    //                     setLoading(true);
    //                     const verifyPayload = {
    //                         razorpay_order_id: response.razorpay_order_id,
    //                         razorpay_payment_id: response.razorpay_payment_id,
    //                         razorpay_signature: response.razorpay_signature,
    //                         orderId: orderId,
    //                     };
    //                     const verifyResponse = await apiPOST(`/v1/payment/verify-payment`, verifyPayload);
    //                     if (verifyResponse.status) {
    //     toast.success("Payment successful!");
    //     setLoading(false);
    //     navigate(`/success?orderId=${orderId}`, {
    //     state: { paymentData: verifyResponse?.data?.data }
    // });
    // } else {
    //                         toast.error("Payment verification failed");
    //                         setLoading(false);
    //                         navigate(`/cancel?orderId=${orderId}`);
    //                     }
    //                 } catch (error) {
    //                     console.error("Error verifying payment::", error);
    //                     toast.error("Error verifying payment");
    //                     setLoading(false);
    //                 }
    //             },
    //             // Called when user closes the modal
    //             modal: {
    //                 ondismiss: function () {
    //                     toast.warning("Payment cancelled");
    //                     setLoading(false);
    //                 },
    //             },
    //         };

    //         const rzp = new window.Razorpay(options);

    //         // Handle payment failures
    //         rzp.on("payment.failed", function (response) {
    //             console.error("Payment failed::", response.error);
    //             toast.error(`Payment failed: ${response.error.description}`);
    //             setLoading(false);
    //         });

    //         rzp.open();
    //     }; 

    // ─────────────────────────────────────────────
    // Open Razorpay Modal (Configured for UPI, Netbanking & Wallets)
    // ─────────────────────────────────────────────
    const openRazorpayModal = (checkoutData, orderId) => {
        const options = {
            key: checkoutData.key_id,
            amount: checkoutData.amount,
            currency: checkoutData.currency,
            order_id: checkoutData.razorpayOrderId,
            name: "MEDiiAPP",
            description: "Order Payment",

            // ─────────────────────────────────────────────
            // CONFIG TO REMOVE CARDS & SHOW DIGITAL ONLY
            // ─────────────────────────────────────────────
            config: {
                display: {
                    // This keeps the sidebar layout visible as seen in your image
                    blocks: {
                        // Block 1: UPI
                        upi_block: {
                            name: "UPI",
                            instruments: [{ method: "upi" }]
                        },
                        // Block 2: Netbanking
                        netbanking_block: {
                            name: "Netbanking",
                            instruments: [{ method: "netbanking" }]
                        },
                        // Block 3: Wallets (Restricted to Mobikwik)
                        wallet_block: {
                            name: "Wallet",
                            instruments: [
                                {
                                    method: "wallet",
                                    wallets: ["mobikwik"] // Hides Airtel, Ola, Jio, etc.
                                }
                            ]
                        }
                    },
                    // We EXCLUDE "card" from this sequence to hide it
                    sequence: ["block.upi_block", "block.netbanking_block", "block.wallet_block"],
                    preferences: {
                        // Set to false so Razorpay doesn't try to add back the Card section automatically
                        show_default_blocks: false
                    }
                }
            },
            // ─────────────────────────────────────────────

            prefill: {
                name: checkoutData.customer_name,
                email: checkoutData.customer_email,
                contact: checkoutData.customer_phone || "", // Added phone if available
            },
            theme: {
                color: "#14967F", // Your brand color from UI
            },

            // Called when payment is successful
            handler: async function (response) {
                try {
                    setLoading(true);
                    const verifyPayload = {
                        razorpay_order_id: response.razorpay_order_id,
                        razorpay_payment_id: response.razorpay_payment_id,
                        razorpay_signature: response.razorpay_signature,
                        orderId: orderId,
                    };

                    const verifyResponse = await apiPOST(`/v1/payment/verify-payment`, verifyPayload);

                    if (verifyResponse.status) {
                        toast.success("Payment successful!");
                        setLoading(false);
                        navigate(`/success?orderId=${orderId}`, {
                            state: { paymentData: verifyResponse?.data?.data }
                        });
                    } else {
                        toast.error("Payment verification failed");
                        setLoading(false);
                        navigate(`/cancel?orderId=${orderId}`);
                    }
                } catch (error) {
                    console.error("Error verifying payment::", error);
                    toast.error("Error verifying payment");
                    setLoading(false);
                }
            },

            // Called when user closes the modal
            modal: {
                ondismiss: function () {
                    toast.warning("Payment cancelled");
                    setLoading(false);
                },
            },
        };

        const rzp = new window.Razorpay(options);

        // Handle payment failures
        rzp.on("payment.failed", function (response) {
            console.error("Payment failed::", response.error);
            toast.error(`Payment failed: ${response.error.description}`);
            setLoading(false);
        });

        rzp.open();
    };

    const addOrderAndItems = async () => {
        if (!isServiceable) {
            toast.error("Shipping is not available for this location.");
            return;
        }
        setLoading(true);

        // ─────────────────────────────────────────────
        // COD Flow (unchanged)
        // ─────────────────────────────────────────────
        if (selectedOption === 'cod') {
            const addCodOrderPayload = {
                userId,
                addressId: stepperProgressCartData?.selectedAddress?._id,
                prescriptionId: stepperProgressCartData?.selectedPrescription[0]?._id,
                orderType: selectedOption,
                mode: 'order',
                totalPayment: stepperProgressCartData?.totalCartAmount,
                delivery_charges: globalConfig?.deliveryCharges,
                packaging_charges: globalConfig?.packagingCharges
            };
            try {
                const addCodOrderResponse = await apiPOST(`/v1/order/add`, addCodOrderPayload);
                if (addCodOrderResponse?.data?.data && stepperProgressCartData?.cartData?.length) {
                    toast.success('Order Placed successfully');
                    stepperProgressCartData?.cartData.map(async (item) => {
                        const addOrderItemPayload = {
                            orderId: addCodOrderResponse?.data?.data?.id,
                            productId: item?.productId,
                            quantity: item?.quantity,
                        };
                        try {
                            const orderItemResponse = await apiPOST(`/v1/order-item/add`, addOrderItemPayload);
                            if (orderItemResponse) {
                                setLoading(false);
                                navigate(`/cod-success-page/${addCodOrderResponse?.data?.data?.id}`);
                            }
                        } catch (error) {
                            console.log("Error Order Adding Item::", error);
                        }
                    });
                }
            } catch (error) {
                console.log('Error adding COD order::', error);
                setLoading(false);
            }

            // ─────────────────────────────────────────────
            // ONLINE PAYMENT Flow (Stripe → Razorpay)
            // ─────────────────────────────────────────────
        } else {
            try {
                // Step 1: Load Razorpay script
                const scriptLoaded = await loadRazorpayScript();
                if (!scriptLoaded) {
                    toast.error("Failed to load Razorpay. Check your connection.");
                    setLoading(false);
                    return;
                }

                // Step 2: Create order
                const addOrderPayload = {
                    userId,
                    addressId: stepperProgressCartData?.selectedAddress?._id,
                    prescriptionId: stepperProgressCartData?.selectedPrescription[0]?._id,
                    orderType: selectedOption,
                    mode: 'order',
                    totalPayment: stepperProgressCartData?.totalCartAmount,
                    delivery_charges: globalConfig?.deliveryCharges,
                    packaging_charges: globalConfig?.packagingCharges
                };

                const addOrderResponse = await apiPOST(`/v1/order/add`, addOrderPayload);
                if (!addOrderResponse?.status) {
                    toast.error("Error adding order");
                    setLoading(false);
                    return;
                }

                toast.success('Order added successfully');

                // Step 3: Add order items
                const addOrderItemsPromises = stepperProgressCartData?.cartData.map(async (item) => {
                    const addOrderItemPayload = {
                        orderId: addOrderResponse?.data?.data?.id,
                        productId: item?.productId,
                        quantity: item?.quantity,
                    };
                    try {
                        return await apiPOST(`/v1/order-item/add`, addOrderItemPayload);
                    } catch (error) {
                        console.log("Error Adding Order Item::", error);
                        return null;
                    }
                });

                const orderItemsResponses = await Promise.all(addOrderItemsPromises);
                const allOrderItemsAdded = orderItemsResponses.every(response => response && response.status);

                if (!allOrderItemsAdded) {
                    toast.error('Error adding order items');
                    setLoading(false);
                    return;
                }

                // Step 4: Create Razorpay order from backend
                // Previously: got a redirect URL from Stripe
                // Now: get razorpayOrderId + key_id to open modal
                const checkoutPayload = {
                    mode: 'order',
                    orderType: selectedOption,
                };

                const checkoutResponse = await apiPOST(
                    `/v1/payment/create-checkout/${addOrderResponse?.data?.data?.id}`,
                    checkoutPayload
                );

                if (checkoutResponse?.status) {
                    // Step 5: Open Razorpay modal
                    // Previously: window.location.replace(checkoutUrl)
                    // Now: open Razorpay modal directly on page
                    openRazorpayModal(
                        checkoutResponse?.data?.data,
                        addOrderResponse?.data?.data?.id
                    );
                } else {
                    toast.error('Failed to create checkout session');
                    setLoading(false);
                }

            } catch (error) {
                toast.error('Error processing payment');
                console.error(error);
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        scrollToTop();
    }, []);

    return (
        <div>
            <div className="lg:flex gap-5 my-4">
                <div className="lg:w-1/2 flex flex-col">
                    <h2 className="text-2xl font-bold text-[18px]">Select Your Payment Method</h2>
                    <div className="space-y-4 p-4">
                        <div className={`flex items-center p-4 border rounded-lg bg-[#FFFFFF] ${selectedOption === 'online' ? 'border-green-500' : 'border-gray-300'}`}>
                            <input
                                type="radio"
                                id="payOnline"
                                name="paymentOption"
                                value="online"
                                checked={selectedOption === 'online'}
                                onChange={handleOptionChange}
                                className="form-radio h-5 w-5 text-green-500 cursor-pointer"
                            />
                            <label htmlFor="payOnline" className="ml-3 text-lg cursor-pointer font-medium">
                                Pay Online
                            </label>
                        </div>
                        <div className={`flex items-center p-4 border rounded-lg bg-[#FFFFFF] ${selectedOption === 'cod' ? 'border-green-500' : 'border-gray-300'}`}>
                            <input
                                type="radio"
                                id="cashOnDelivery"
                                name="paymentOption"
                                value="cod"
                                checked={selectedOption === 'cod'}
                                onChange={handleOptionChange}
                                className="form-radio h-5 w-5 text-green-500 cursor-pointer"
                            />
                            <label htmlFor="cashOnDelivery" className="ml-3 text-lg cursor-pointer font-medium">
                                Cash on Delivery
                            </label>
                        </div>
                    </div>
                    <div className={`${stepperProgressCartData?.cartData?.length === 0 ? 'hidden' : 'lg:ml-auto'}`}>
                        <ButtonWithLoader
                            loading={loading}
                            // Disable if not serviceable OR if already loading
                            disabled={!isServiceable || loading}
                            buttonText={selectedOption === 'cod' ? "Place order" : "Proceed to payment"}
                            onClick={addOrderAndItems}
                            width={"w-[200px]"}
                            // Optional: Make the button look grey/faded when disabled
                            className={`${!isServiceable ? 'opacity-50 cursor-not-allowed grayscale' : ''}`}
                        />
                    </div>
                </div>
                <div className="flex flex-col lg:w-1/2">
                    {/* <PaymentSummary type="summary" item={stepperProgressCartData ? stepperProgressCartData : []} globalConfig={globalConfig} /> */}
                    <PaymentSummary
                        item={stepperProgressCartData}
                        globalConfig={globalConfig}
                        setCanPay={setIsServiceable} // This links the two components
                    />
                    <AttachedPrescription type="cart" stepperProgressCartData={stepperProgressCartData} />
                </div>
            </div>
        </div>
    );
};

export default PaymentStep;